import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext/ThemeContext";
import { useLanguage } from "../context/language/LanguageContext";

import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import ForgotPassword from "./pages/ForgotPassword";
import Error404 from "./pages/Error404";
import Donors from "./components/Donors/DonorsCards";
import DonorsTables from "./components/Donors/DonorsTables";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import "./rtl-fix.css";

const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const { language } = useLanguage();

  // set <html dir> for global direction (scrollbars, alignment, etc.)
  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language]);

  // get path to decide if login/register pages
  let path = window.location.pathname.split("/").pop();
  let pagePath = path.split("-").includes("page");

  return (
    <Router basename="/">
      <div
        dir={language === "ar" ? "rtl" : "ltr"} // 👈 direction applied here
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          >
            <Switch>
              {/* Public Routes */}
              <Route path="/page-login" component={Login} />
              {/* <Route path="/page-register" component={Registration} />
              <Route path="/page-forgot-password" component={ForgotPassword} /> */}

              {/* Private (Protected) Routes */}
              <PrivateRoute exact path="/" component={Donors} />
              <PrivateRoute exact path="/donors" component={Donors} />
              <PrivateRoute
                exact
                path="/donors/donor-tables/:type"
                component={DonorsTables}
              />

              {/* 404 Fallback */}
              <Route component={Error404} />
            </Switch>
          </div>
        </div>

        {!pagePath && <Footer />}
      </div>
    </Router>
  );
};

export default Markup;
